import { useState } from 'react';
import Cookies from 'js-cookie';
import jwt from "jwt-decode";
import { useNavigate } from 'react-router-dom';
import Config from './Config';
import { clearAuthStorage } from "./authStorage";

export function useAuthHandling() {
  let navigate = useNavigate();

  const [isAuthorized, setIsAuthorized] = useState(true);
  const refreshtoken=Cookies.get("reToken");

  const handleUnauthorized = async () => {
    if (!refreshtoken) {
      clearAuthStorage();
      navigate("/");
      setIsAuthorized(false);
      return;
    }

    const toekns = jwt(refreshtoken);
    const expirationTime = (toekns.exp * 1000) - 60000;
    const date = Date.now();

    if (date >= expirationTime){
      clearAuthStorage();
      navigate("/");
    } else {
      const res = await fetch(`${Config.apiurl}/api/v1/crm/refresh-token`, {
        method: "POST",
        body: JSON.stringify({
          refreshToken: refreshtoken,
        }),
        headers: {
          "Content-Type": "application/json",
        },
  
      });
  
      if (res.status === 200) {
        const data1 = await res.json();
        if(data1.status===true){
          const data = data1.data;
          Cookies.set("a_token", data[0].token);
          const user = jwt(data[0].token); 
          Cookies.set("User_type", user.currentUserType);
        }    
      } else if(res.status===401){
        clearAuthStorage();
        navigate("/");
      } else {
        console.log("");
      }
    }

    setIsAuthorized(false);
  };


  return { isAuthorized, handleUnauthorized };
}
